<template>
  <div id="login" class="relative">
    <template v-if="isAuthenticated">
      <PageSidebar>
        <div class="flex flex-col items-center justify-center gap-8">
          <div class="swal2-icon swal2-success swal2-animate-success-icon">
            <div class="swal2-success-circular-line-left" style="background-color: rgb(255, 255, 255)" />
            <span class="swal2-success-line-tip" />
            <span class="swal2-success-line-long" />
            <div class="swal2-success-ring" />
            <div class="swal2-success-fix" style="background-color: rgb(255, 255, 255)" />
            <div class="swal2-success-circular-line-right" style="background-color: rgb(255, 255, 255)" />
          </div>

          <div>
            {{ trans('Please wait. You are being redirected.') }}
          </div>
        </div>
      </PageSidebar>

      <div class="absolute bottom-2 left-2 right-2">
        <MdlProgressBar indeterminate class="rounded-[2px] overflow-hidden" />
      </div>
    </template>

    <template v-else>
      <PageSidebar />

      <div class="login-right">
        <PageHeader>
          <DefinitionList v-if="invite" class="mt-8">
            <DefinitionItem :term="trans('Invitation code')" :description="invite.code" />
            <DefinitionItem :term="trans('Invited by')" :description="invite.ownerCompany.name" />
          </DefinitionList>
        </PageHeader>

        <div class="login-content flex flex-col">
          <router-view />
        </div>
      </div>

      <div v-if="isLoading" class="login-progress">
        <MdlProgressBar indeterminate />
      </div>

      <PageFooter />
    </template>
  </div>
</template>

<script>
import { trans } from '@/munio/i18n'
import DefinitionList from '@component/DefinitionList.vue'
import DefinitionItem from '@component/DefinitionItem.vue'
import MdlProgressBar from '@component/mdl/ProgressBar.vue'
import PageSidebar from './Sidebar.vue'
import PageHeader from './Header.vue'
import PageFooter from './Footer.vue'

export default {
  name: 'Auth',

  components: {
    DefinitionList,
    DefinitionItem,
    MdlProgressBar,
    PageSidebar,
    PageHeader,
    PageFooter,
  },

  computed: {
    isLoading() {
      return this.$store.state.loading
    },

    isAuthenticated() {
      return this.$store.state.authenticated && !this.$store.state.userInvite
    },

    pageBackground() {
      return this.$store.state.company.backgroundUrl
    },

    transition() {
      return this.$store.state.transition
    },

    body() {
      return document.getElementsByTagName('body')[0]
    },

    background() {
      return document.getElementById('background')
    },

    invite() {
      return this.$store.state.invite
    },
  },

  methods: {
    trans,

    updateBackground(url) {
      if (url) {
        this.background.style.backgroundImage = `url(${url})`
      }
    },
  },

  mounted() {
    this.$store.commit('reset')
    this.updateBackground(this.pageBackground)
  },

  watch: {
    isLoading(value) {
      if (value) {
        this.body.classList.add('is-loading')
      } else {
        this.body.classList.remove('is-loading')
      }
    },

    pageBackground(value) {
      this.updateBackground(value)
    },
  },
}
</script>

<style scoped>
.login-right {
  overflow: hidden;
}

.login-header {
  background-color: transparent;
}

.login-content form {
  min-height: 240px;
}
</style>
